import { FaqCategoryItem, FaqMatchedItem } from './../faq.model';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlightSearch'
})
export class HighlightSearchPipe implements PipeTransform {

    constructor() {
    }

    transform(items: FaqCategoryItem[], searchText: string): FaqMatchedItem[] {
        let result: FaqMatchedItem[] = [];

        if (!searchText) {
            return result;
        }
        // strimming whitespace
        searchText  = searchText.replace(/\s{2}/g, ' ');
        items.forEach(item  => {
            // escape html tag
            item.question = this.escapeHtml(item.question);
            item.answer = this.escapeHtml(item.answer);
            // contains searchText or not ?
            if (this.containSearchText(item, searchText)) {
                 result.push(this.highlightItem(item, searchText));
            }
        });

      return result;
    }

    private highlightItem(item: FaqCategoryItem, searchText: string): FaqMatchedItem {
        const question = this.highlightText(item.question, searchText);
        const answer = this.highlightText(this.truncateAnswer(item.answer, searchText), searchText);
        let matchedItem = {
            'id': item.id,
            'question': question,
            'answer': answer
        };
        return matchedItem;
    }

    private highlightText(text: string, searchText: string): string {
        let highlightedText = text;
        searchText.split(' ').filter(word => word.trim().length > 0).forEach(word => {
            // Match in a case insensitive maneer
            const re = new RegExp(word, 'gi');
            const match = highlightedText.match(re);
            // If there's no match, just return the original value.
            if (match) {
                highlightedText = highlightedText.replace(re, `<mark>${match[0]}</mark>`);
            }
        });
        return highlightedText;
    }

    private truncateAnswer(answer: string, searchText: string): string {
        let truncatedText = null;
        searchText.split(' ').filter(word => word.trim().length > 0).forEach(word => {
            let pattern = `([a-zA-Z0-9À-ÿ\\.,;:-]+\\s+){0,4}${ word }\\S*(\\s+[a-zA-Z0-9À-ÿ\\.,;:-]+){0,4}`;
            // Match in a case insensitive maneer
            const re = new RegExp(pattern, 'gi');
            const match = answer.match(re);
            // If there's no match, just return the original value.
            if (match) {
                truncatedText = match[0];
            }
        });
        if (truncatedText == null) {
            truncatedText = answer.length < 100 ? answer : answer.substr(0, 100);
        }
        return `$[...] ${truncatedText } [...]`;
    }

    private containSearchText(item: FaqCategoryItem, searchText: string): boolean {
        return searchText.split(' ').filter(word => word.trim().length > 0).some((word) => this.containWord(word, item));
    }

    private containWord(word: string, item: FaqCategoryItem): boolean {
        const re = new RegExp(word, 'gi');
        const matchQuestion = item.question.match(re);
        const matchAnswer = item.answer.match(re);
        if (matchQuestion || matchAnswer) {
            return true;
        }
       return false;
    }

    private escapeHtml(text: string): string {
        let escapedText = '';
        if (text) {
            // remove html tags
            escapedText = text.replace(/<[^>]*>/g, '');
        }
        return escapedText;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/faq/faq-search/highlight-search.pipe.ts